import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'

interface GoogleReviewStyle {
  wrapper: SxProps
  logo: SxProps
  text: SxProps
}

export const googleReviewStyle: GoogleReviewStyle = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    background: 'background',
    borderRadius: '50px',
    py: 0.5,
    px: 1,
    gap: 0.5,
  },
  logo: {
    width: 24,
  },
  text: {
    typography: 'textXs',
    fontWeight: FONT_WEIGHTS.SEMI_BOLD,
  },
}
